<template>
  <span v-if="crossed == 1">
    <s>{{ first }}{{ asterisk }}</s>
    <br v-if="breakLine" />
    {{ separator }}
    <span>{{ second }}{{ asterisk }}</span>
  </span>
  <span v-else-if="crossed == 2">
    <span>{{ first }}{{ asterisk }}</span>
    <br v-if="breakLine" />
    {{ separator }}
    <s>{{ second }}{{ asterisk }}</s>
  </span>
  <span v-else>
    <span>{{ first }}{{ asterisk }}</span>
    <br v-if="breakLine" />
    {{ separator }}
    <span>{{ second }}{{ asterisk }}</span>
  </span>
</template>

<script>
export default {
  name: 'WCrossedOut',
  props: {
    crossed: Number,
    separator: {
      type: String,
      default: '/'
    },
    asterisk: {
      type: String,
      default: '*'
    },
    first: String,
    second: String,
    breakLine: Boolean
  }
};
</script>

<style></style>
